// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","tertiary":"#BFD730","outer":"_13_U","me":"_1XT9","message":"_3giz","other":"_1OUC","timestamp":"_1nU0"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Messages/Message/Message.scss
// module id = DZ/X
// module chunks = 0